// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { Tooltip, Popover } from "react-bootstrap";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import AdminApi from "../../../api/adminApi";
import SendEmailApi from "../../../api/sendEmailApi";
import { toast } from "react-toastify";
import ServiceApi from "../../../api/serviceApi";
import AuthApi from "../../../api/authApi";
import RolesApi from "../../../api/rolesApi";
import TalksApi from "../../../api/talksApi";
import PerishApi from "../../../api/parishApi";
import ParishCategoryApi from "../../../api/parishCategoryApi";
import DeaneryApi from "../../../api/deaneryApi";
import { formatParishOptionLabel, sortParishesByName } from "../../../utils/parishLabels";
import { formatCoupleOptionLabel } from "../../../utils/coupleLabels";
import RetreatApi from "../../../api/retreatApi";
import RetreatRoastApi from "../../../api/retreatRosterApi";
import moment from "moment";
import { useAuthUser } from "../../../hooks/useAuthUser";
import { setBrokenImageFallback } from "../../../utils/imageFallback";
import { isProtectedDemoCouple } from "../../../utils/demoAccounts";
import Profile from "../../../assets/images/couple-default.png";
import corruptedImg from "../../../assets/images/corrupted-img.png";
import UpdateCouplePopUp from "../../Common/UpdateCouplePopUp";
import MasterPageShell from "../../../components/masterData/MasterPageShell";
import { SlidersHorizontal, Eye, EyeOff } from "lucide-react";
import SearchForm from "./SearchForm";
import SearchResultsBar from "./SearchResultsBar";
import SearchTables from "./SearchTables";
import ComposeEmailModal from "./ComposeEmailModal";
import { createSearchExports } from "./searchExports";
import { buildSearchColumns } from "./searchColumns";
import { reportTitle } from "./reportPresets";
import styles from "./SearchData.module.scss";

function buildParishOptions(rows, categories, deaneries) {
  const categoryIds = new Set((categories || []).map((item) => String(item.value)));
  const deaneryIds = new Set((deaneries || []).map((item) => String(item.value)));
  const parishList = [];
  (rows || []).forEach((item) => {
    if (!item?.parish || item.parishCategoryName?.toUpperCase() === "OTHER") return;
    const categoryId =
      item.parishCategoryId !== undefined && item.parishCategoryId !== null
        ? String(item.parishCategoryId)
        : "";
    const deaneryId = String(item.deaneryId ?? item.deanery_id ?? "");
    if (categoryIds.size && !categoryIds.has(categoryId)) return;
    if (deaneryIds.size && !deaneryIds.has(deaneryId)) return;
    parishList.push({
      label: formatParishOptionLabel(item),
      value: item.id,
    });
  });
  return parishList.sort((a, b) => a.label.localeCompare(b.label));
}

const SearchData = () => {
  let navigate = useNavigate();
  const location1 = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const [validated, setValidated] = useState(false);
  const [mailshow, setMailShow] = useState(false);
  const [show, setShow] = useState(false);
  const [mail_id, SetMail_id] = useState("");
  const [sendEmailList, setSendEmailList] = useState<any[]>([]);
  const [cp, setCp] = useState(false);
  const [composedMails, setComposedMails] = useState<any[]>([]);
  const [allCoupleData, setAllCoupleData] = useState<any[]>([]);
  const [allCoupleList, setAllCoupleList] = useState<any[]>([]);
  const [selectedData, setselectedData] = useState<any[]>([]);
  const [serviceDataList, setServiceDataList] = useState<any[]>([]);
  const [rolesDataList, setrolesDataList] = useState<any[]>([]);
  const [talksDataList, setTalksDataList] = useState<any[]>([]);
  const [parishDataList, setParishDataList] = useState<any[]>([]);
  const [allRetreatData, setAllRetreatData] = useState<any[]>([]);
  const [selectRetreat, setSelectRetreat] = useState<any>(null);
  const [selectCouple, setSelectCouple] = useState<any>(null);
  const [selectParish, setSelectParish] = useState<any>(null);
  const [couplesList, setCouplesList] = useState<any[]>([]);
  const [retreatsList, setRetreatsList] = useState<any[]>([]);
  const [roasterCount, setRoasterCount] = useState("");
  const [LoadData, setLoadData] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const initialEditorContent =
    "Hello ${firstName} ${lastName}, <br /> <strong>Here we are inviting you on the Retreat- </strong><br />Scott ,Robot and Maria <br />  March 2-3 , 2023 : St.Mattew's,Eng,San Antonio <br /> \n We look forward to see you there </br>\n   Thank you! </br> LOVESTRONG Marriage.";
  const [defaultEditorContent, setDefaultEdtitorContent] =
    useState(initialEditorContent);
  const [maildata, setMailData] = useState({
    couple: [],
    subject: "",
    message: "",
  });
  const [ciytState, setCityState] = useState<any[]>([]);
  const [selectedStateCity, setSelectedStateCity] = useState<any[]>([]);
  const [location, setLocation] = useState<any[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<any[]>([]);
  const [selectedZips, setSelectedZips] = useState<any[]>([]);
  const year = new Date().getFullYear();
  const month = new Date().getMonth() + 1;
  const day = "01";
  const searchInitial = {
    retreatId: 0,
    parisheId: 0,
    coupleId: 0,
    cityState: [],
    location: [],
    primaryKey: 0,
    dateFrom: "",
    dateTo: "",
    retreatAttended: false,
    language: 0,
    serviceIds: [],
    roleIds: [],
    talkIds: [],
    accountStatus: [],
    neverServedTeam: false,
    neverServiceRole: false,
    neverTalk: false,
    retreatants: [],
    searchFor: "retreat",
    zip: [],
    missingMails: false,
    parishCategoryId: [],
    deaneryId: [],
  };

  const [searchQuery, setSearchQuery] = useState(searchInitial);
  const [Message, setMessage] = useState(defaultEditorContent);
  let adminApi = new AdminApi();
  let authApi = new AuthApi();
  let serviceApi = new ServiceApi();
  let sendEmailApi = new SendEmailApi();
  let rolesApi = new RolesApi();
  let talksApi = new TalksApi();
  let perishApi = new PerishApi();
  let retreatApi = new RetreatApi();
  const userData = useAuthUser();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isShowData, setIsShowData] = useState(false);
  const [noRetAttend, setNoRetAttend] = useState(false);
  const [coupWithAttenType, setCoupWithAttenType] = useState(false);
  const [allDates, setAllDates] = useState(true);
  const [searchFor, setSearchFor] = useState("retreat");
  let reportId = searchParams.get("reportId");
  const scollToRef = useRef();
  const [roleTextArray, setRoleTextArray] = useState<any[]>([]);
  const [serviceTextArray, setServiceTextArray] = useState<any[]>([]);
  const [talkTextArray, setTalkTextArray] = useState<any[]>([]);
  const [open1, setOpen1] = useState(true);
  const [showRegModal, setShowREgModal] = useState(false);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState("");
  const [isEditAdmin, setIsEditAdmin] = useState(false);
  const [roast_id, setRoast_id] = useState("");
  const [roastersOfCoupleList, setRoastersOfCoupleList] = useState<any[]>([]);
  const [quickSearchFor, setQuickSearchFor] = useState("");
  const [dataCount, setDataCount] = useState<any[]>([]);
  const [oldValues, setOldValues] = useState<any[]>([]);
  const [zip, setZip] = useState<any[]>([]);
  const [retreatOptions, setRetreatOptions] = useState<any[]>([]);
  const [selectedRetreats, setSelectedRetreats] = useState<any[]>([]);
  const [parishOptions, setParishOptions] = useState<any[]>([]);
  const [selectedParishes, setSelectedParishes] = useState<any[]>([]);
  const [categoryOptions, setCategoryOptions] = useState<any[]>([]);
  const [allDeaneries, setAllDeaneries] = useState<any[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
  const [selectedDeaneries, setSelectedDeaneries] = useState<any[]>([]);
  const geoFiltersRef = useRef({ categories: [], deaneries: [] });
  const [selectLanguage, setSelectLanguage] = useState<any[]>([]);
  const [languagesOptions, setLanguagesOptions] = useState([
    { label: "English", value: "english" },
    { label: "Spanish", value: "spanish" },
  ]);
  const [selectedLanguages, setSelectedLanguages] = useState<any[]>([]);
  const [coupleOptions, setCoupleOptions] = useState<any[]>([]);
  const [selectedCouples, setSelectedCouples] = useState<any[]>([]);
  const [isTempUpload, setIsTempUpload] = useState(false);
  const [isTempUpload2, setIsTempUpload2] = useState(false);

  const [data, setData] = useState({
    id: "",
    hisFirstName: "",
    hisLastName: "",
    hisEmail: "",
    hisMobile: "",
    herFirstName: "",
    herLastName: "",
    herEmail: "",
    herMobile: "",
    city: "",
    state: "",
    zip: "",
    notes: "",
    imageUrl: "",
    parishId: null,
    address: "",
    allergies: "",
    anniversary_date: "",
    under_age_35: "NO",
    emergency_name1: "",
    emergency_relationship1: "",
    emergency_phone1: "",
    emergency_name2: "",
    emergency_relationship2: "",
    emergency_phone2: "",
    hear_us: [],
    referral_from_a_friend_or_family_member: "",
  });
  const [alreadyPk, setAlreadyPk] = useState();
  const handleShow = (item: any) => {
    setRoast_id(item);
    setShow(true);
  };

  const renderTooltip = (props: any) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const popover = (row: any) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                row.hisLastName +
                  ", " +
                  row.hisFirstName +
                  " and " +
                  row.herFirstName}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  useEffect(() => {
    getPerishList();
  }, [searchFor]);

  useEffect(() => {
    new ParishCategoryApi().getAllCategories().then((res: any) => {
      if (!res?.success) return;
      const options = [...(res.data || [])]
        .sort((a, b) => {
          if (a.name === "OTHER") return 1;
          if (b.name === "OTHER") return -1;
          return String(a.name || "").localeCompare(String(b.name || ""));
        })
        .map((category) => ({ label: category.name, value: category.id }));
      setCategoryOptions(options);
    });
    new DeaneryApi().list().then((res: any) => {
      if (!res?.success) return;
      const rows = [...(res.data || [])].sort((a, b) =>
        String(a.deaneryName || "").localeCompare(String(b.deaneryName || "")),
      );
      setAllDeaneries(rows);
    });
  }, []);

  let talkids1 = [];
  const getTalksList = async () => {
    await talksApi
      .getAllTalkSearch()
      .then(async (response) => {
        const sortedList = response.data.sort((a, b) =>
          a.talk.localeCompare(b.talk)
        );
        setTalksDataList(sortedList);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  let serviceIds1 = [];
  const getServiceList = async () => {
    await serviceApi
      .getAllServiceSearch()
      .then(async (response) => {
        const sortedList = response.data.sort((a, b) =>
          a.service.localeCompare(b.service)
        );
        setServiceDataList(sortedList);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  let roleIds1 = [];
  const getrolesList = async () => {
    await rolesApi
      .getAllRoleSearch()
      .then(async (response) => {
        // const sortedList = response.data.sort((a, b) =>
        //   a.role.localeCompare(b.role));
        setrolesDataList(response.data);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  useEffect(() => {
    if (location1.state !== null) {
      setOpen1(!open1);
      getTalksList();
      getServiceList();
      const filter = location1.state;
      if (filter.reportId == 1) {
        setLoadData(true);
        serviceApi
          .getAllServiceSearch()
          .then(async (res) => {
            res.data.forEach((s) => {
              serviceIds1.push(s.id);
            });
            if (serviceIds1 && serviceIds1.length) {
              const d = Object.assign(searchQuery, searchQuery);
              // d.searchFor = 'couple'
              d.retreatId = filter.filter.retreatId;
              d.dateFrom = filter.filter.dateFrom;
              d.dateTo = filter.filter.dateTo;
              d.searchFor = "couple";
              serviceIds1 &&
                serviceIds1 !== "" &&
                serviceIds1.map((item) => {
                  d.serviceIds.push(item);
                });
              setSearchQuery(d);
              setLoadData(false);
              searchRetreatsAndCouples();
              setQuickSearchFor(reportTitle(1));
            } else {
              setLoadData(false);
            }
          })
          .catch((error: any) => {
            setLoadData(false);
            toast.error(error.toString());
          });
      } else if (filter.reportId == 2) {
        const d = Object.assign(searchQuery, searchQuery);
        d.retreatId = filter.filter.retreatId;
        d.dateFrom = filter.filter.dateFrom;
        d.dateTo = filter.filter.dateTo;
        d.searchFor = "couple";
        // d.searchFor = 'couple'
        d.neverServedTeam = true;
        setSearchQuery(d);
        searchRetreatsAndCouples();
        setQuickSearchFor(reportTitle(2));
      } else if (filter.reportId === 3) {
        setLoadData(true);
        talksApi
          .getAllTalkSearch()
          .then(async (response) => {
            response.data.forEach((item) => {
              talkids1.push(item.talkId);
            });
            if (talkids1 && talkids1.length) {
              const d = Object.assign(searchQuery, searchQuery);
              d.retreatId = filter.filter.retreatId;
              d.dateFrom = filter.filter.dateFrom;
              d.dateTo = filter.filter.dateTo;
              d.searchFor = "couple";
              talkids1 &&
                talkids1 !== "" &&
                talkids1.map((item) => {
                  d.talkIds.push(item);
                });
              setSearchQuery(d);
              setLoadData(false);
              searchRetreatsAndCouples();
              setQuickSearchFor(reportTitle(3));
            } else {
              setLoadData(false);
            }
          })
          .catch((error: any) => {
            setLoadData(false);
            toast.error(error.toString());
          });
      } else if (filter.reportId == 4) {
        const d = Object.assign(searchQuery, searchQuery);
        d.retreatId = filter.filter.retreatId;
        d.dateFrom = filter.filter.dateFrom;
        d.dateTo = filter.filter.dateTo;
        d.searchFor = "couple";
        d.neverTalk = true;
        setSearchQuery(d);
        searchRetreatsAndCouples();
        setQuickSearchFor(reportTitle(4));
      } else if (filter.reportId == 6) {
        setLoadData(true);
        const d = Object.assign(searchQuery, searchQuery);
        d.retreatId = filter.filter.retreatId;
        d.dateFrom = new Date(
          new Date().setFullYear(new Date().getFullYear() - 2)
        );
        d.dateTo = new Date();
        // let retreatantType = d.retreatants.findIndex((s) => s == 'Retreatant')
        // if (retreatantType != -1) {
        //   d.retreatants.splice(retreatantType, 1)
        // } else {
        //   d.retreatants.push('Retreatant')
        // }
        let retreatantType1 = d.retreatants.findIndex((s) => s == "Team");
        if (retreatantType1 != -1) {
          d.retreatants.splice(retreatantType1, 1);
        } else {
          d.retreatants.push("Team");
        }
        setSearchQuery(d);
        setLoadData(false);
        searchRetreatsAndCouples();
        setQuickSearchFor(reportTitle(6));
      } else if (filter.reportId == 7) {
        const d = Object.assign(searchQuery, searchQuery);
        d.retreatId = filter.filter.retreatId;
        d.dateFrom = filter.filter.dateFrom;
        d.dateTo = filter.filter.dateTo;
        d.searchFor = "couple";
        d.accountStatus.push("ACTIVE", "DECEASED", "DIVORCED");
        setSearchFor("couple");
        setSearchQuery(d);
        searchRetreatsAndCouples();
      } else if (filter.reportId == 8) {
        setLoadData(true);
        rolesApi
          .getAllRoleList()
          .then(async (res) => {
            let serviceId = res.data.find((s) => s.role == "Lead");
            roleIds1.push(serviceId.id);
            if (roleIds1 && roleIds1.length) {
              const d = Object.assign(searchQuery, searchQuery);
              d.retreatId = filter.filter.retreatId;
              d.dateFrom = filter.filter.dateFrom;
              d.dateTo = filter.filter.dateTo;
              d.searchFor = "couple";
              roleIds1 &&
                roleIds1 !== "" &&
                roleIds1.map((item) => {
                  d.roleIds.push(item);
                });
              setSearchQuery(d);
              setLoadData(false);
              searchRetreatsAndCouples();
              setQuickSearchFor(reportTitle(8));
            } else {
              setLoadData(false);
            }
          })
          .catch((error: any) => {
            setLoadData(false);
            toast.error(error.toString());
          });
      } else if (filter.reportId == 9) {
        setLoadData(true);
        rolesApi
          .getAllRoleSearch()
          .then(async (res) => {
            let serviceId = res.data.find((s) => s.role == "Head");
            if (serviceId) {
              roleIds1.push(serviceId.id);
              if (roleIds1 && roleIds1.length) {
                const d = Object.assign(searchQuery, searchQuery);
                d.retreatId = filter.filter.retreatId;
                d.dateFrom = filter.filter.dateFrom;
                d.dateTo = filter.filter.dateTo;
                d.searchFor = "couple";
                roleIds1 &&
                  roleIds1 !== "" &&
                  roleIds1.map((item) => {
                    d.roleIds.push(item);
                  });
                setSearchQuery(d);
                setLoadData(false);
                searchRetreatsAndCouples();
                setQuickSearchFor(reportTitle(9));
              }
            } else {
              setLoadData(false);
            }
          })
          .catch((error: any) => {
            setLoadData(false);
            toast.error(error.toString());
          });
      } else if (filter.reportId == 10) {
        setLoadData(true);
        rolesApi
          .getAllRoleList()
          .then(async (res) => {
            let headId = res.data.findIndex((s) => s.role == "Head");
            if (headId != -1) {
              res.data.splice(headId, 1);
            }
            let roleAllIds = res.data.map((s) => s.id);
            if (roleAllIds && roleAllIds.length) {
              const d = Object.assign(searchQuery, searchQuery);
              d.retreatId = filter.filter.retreatId;
              d.dateFrom = filter.filter.dateFrom;
              d.dateTo = filter.filter.dateTo;
              d.searchFor = "couple";
              d.is_Not_Head_Role = location1.state.is_Not_Head_Role;
              roleAllIds &&
                roleAllIds !== "" &&
                roleAllIds.map((item) => {
                  d.roleIds.push(item);
                  setSearchQuery(d);
                });
              setLoadData(false);
              searchRetreatsAndCouples();
              setQuickSearchFor(reportTitle(10));
            } else {
              setLoadData(false);
            }
          })
          .catch((error: any) => {
            setLoadData(false);
            toast.error(error.toString());
          });
      }
      getrolesList();
      AllComposedMailList();
      getAllCouples1();
      getAllRetreats();
      getStateCityCouples();
      getRetreatLocation();
      checkPKCouple();
    } else {
      location1.state = { ...reportId };
      location1.state.reportId = 0;
      getTalksList();
      getrolesList();
      getServiceList();
      AllComposedMailList();
      getAllCouples1();
      getAllRetreats();
      getStateCityCouples();
      getRetreatLocation();
      checkPKCouple();
      setQuickSearchFor("");
    }
    
  }, []);

  const getRetreatLocation = async () => {
    await retreatApi
      .getRetreatLocation()
      .then((res: any) => {
        if (res.success) {
          let retreatLocation = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.location) {
                retreatLocation.push({
                  label: item.location,
                  value: item.location,
                });
              }
            });
          const sortedList = retreatLocation.sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          setLocation(sortedList);
        }
      })
      .catch((error: any) => toast.error(error));
  };

  const getStateCityCouples = async () => {
    await adminApi
      .getStateCity()
      .then((res: any) => {
        if (res.success) {
          let stateCity = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.state) {
                stateCity.push({
                  label: item.state + " - " + item.city,
                  value: item.state + " " + item.city,
                });
              }
            });
          const sortedList = stateCity.sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          setCityState(sortedList);
        }
      })
      .catch((error: any) => toast.error(error));
  };

  const getAllCouples1 = async () => {
    let d = { userRole: "COUPLE" };
    d.export = true;
    await adminApi
      .getAllCouplesSearch(d)
      .then((res: any) => {
        if (res.success) {
          let zipCodes = res.data.map((item) => {
            return item.zip;
          });
          let result = zipCodes.filter((s) => {
            return s != "" && s != null;
          });
          let zipResult = [];
          result.forEach((item) => {
            if (item) {
              let findValue = zipResult.findIndex((s) => s.label == item);
              if (findValue == -1) {
                zipResult.push({
                  label: item,
                  value: item,
                });
              }
            }
          });
          setZip(zipResult);
          let allcoupleList = [];
          res.data &&
            res.data.forEach((item) => {
              if (item.hisFirstName || item.herFirstName || item.hisLastName) {
                allcoupleList.push({
                  label: formatCoupleOptionLabel(item),
                  value: item.id,
                });
              }
            });
          const sort = allcoupleList.sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          // console.log("sort in couples---><", sort);
          setCoupleOptions(sort);

          const sortedList = res.data.sort((a, b) =>
            a.hisLastName > b.hisLastName
              ? 1
              : b.hisLastName > a.hisLastName
              ? -1
              : 0
          );
          setAllCoupleList(sortedList);
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const searchRetreatsAndCouples = () => {
    setLoadData(true);
    retreatApi
      .searchRetreatsAndCouples(searchQuery)
      .then((res: any) => {
        if (res.success && res.retreats && res.retreats.length > 0) {
          if (
            res.retreats &&
            searchQuery.searchFor !== "couple" &&
            searchQuery.retreatants.length == 0 &&
            searchQuery.coupleId == 0 &&
            searchQuery.serviceIds.length == 0 &&
            searchQuery.talkIds.length == 0 &&
            searchQuery.roleIds.length == 0 &&
            searchQuery.neverServedTeam == false &&
            searchQuery.neverServiceRole == false &&
            searchQuery.neverTalk == false &&
            searchQuery.missingMails == false
          ) {
            // show retreats data only
            setLoadData(false);
            setTimeout(() => {
              const element = document.getElementById("section-1");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "end",
                  inline: "nearest",
                });
              }
            }, 500);
            setDataCount(res.retreats.length);
            setIsShowData(false);
            setNoRetAttend(false);
            setCoupWithAttenType(false);
            setRetreatsList(res.retreats);
            let couples = [];

            const filteredData = res.couples.filter(
              (item) =>
                item.accountStatus !== "DIVORCED" &&
                item.accountStatus !== "DECEASED" &&
                item.accountStatus !== "INACTIVE"
            );

            filteredData.forEach((item) => {
              if (item.hisEmail) {
                couples.push({
                  label:
                    item.hisFirstName +
                    " " +
                    item.hisLastName +
                    "(" +
                    item.hisEmail +
                    ")",
                  value: item.hisEmail,
                });
              }
              if (item.herEmail) {
                couples.push({
                  label:
                    item.herFirstName +
                    " " +
                    item.herLastName +
                    "(" +
                    item.herEmail +
                    ")",
                  value: item.herEmail,
                });
              }
            });

            const key = "value";
            const arrayUniqueByKey = [
              ...new Map(couples.map((item) => [item[key], item])).values(),
            ];
            setAllCoupleData(arrayUniqueByKey);
          } else if (
            res.retreats &&
            searchQuery.retreatId == 0 &&
            searchQuery.language == 0 &&
            searchQuery.parisheId == 0 &&
            searchQuery.coupleId == 0 &&
            searchQuery.location.length == 0 &&
            searchQuery.searchFor === "couple" &&
            res.retreats[0].retreatsCount &&
            res.retreats[0].retreatsCount !== ""
          ) {
            // show couples with no. of retreat attended column at the end
            console.log("2");
            setDataCount(res.retreats.length);
            setNoRetAttend(true);
            setLoadData(false);
            setCoupWithAttenType(false);
            setRetreatsList(res.retreats);
            setTimeout(() => {
              const element = document.getElementById("section-1");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "end",
                  inline: "nearest",
                });
              }
            }, 500);
            let couples = [];

            const filteredData = res.retreats.filter(
              (item) =>
                item.accountStatus !== "DIVORCED" &&
                item.accountStatus !== "DECEASED" &&
                item.accountStatus !== "INACTIVE"
            );
            filteredData.forEach((item) => {
              if (item.hisEmail) {
                couples.push({
                  label:
                    item.hisFirstName +
                    " " +
                    item.hisLastName +
                    "(" +
                    item.hisEmail +
                    ")",
                  value: item.hisEmail,
                });
              }
              if (item.herEmail) {
                couples.push({
                  label:
                    item.herFirstName +
                    " " +
                    item.herLastName +
                    "(" +
                    item.herEmail +
                    ")",
                  value: item.herEmail,
                });
              }
            });
            const key = "value";
            const arrayUniqueByKey = [
              ...new Map(couples.map((item) => [item[key], item])).values(),
            ];
            setAllCoupleData(arrayUniqueByKey);
          } else if (
            res.retreats &&
            res.retreats[0].attendeeType &&
            res.retreats[0].attendeeType !== "" &&
            searchQuery.retreatId == 0 &&
            searchQuery.parisheId == 0 &&
            searchQuery.coupleId == 0 &&
            searchQuery.searchFor == "couple"
          ) {
            // show couples with attendee Type
            console.log("3");
            setLoadData(false);
            setTimeout(() => {
              const element = document.getElementById("section-1");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "end",
                  inline: "nearest",
                });
              }
            }, 500);
            setDataCount(res.retreats.length);
            setCoupWithAttenType(true);
            setNoRetAttend(false);
            setRetreatsList(res.retreats);
            let couples = [];
            const filteredData = res.retreats.filter(
              (item) =>
                item.accountStatus !== "DIVORCED" &&
                item.accountStatus !== "DECEASED" &&
                item.accountStatus !== "INACTIVE"
            );
            filteredData.forEach((item) => {
              if (item.hisEmail) {
                couples.push({
                  label:
                    item.hisFirstName +
                    " " +
                    item.hisLastName +
                    "(" +
                    item.hisEmail +
                    ")",
                  value: item.hisEmail,
                });
              }
              if (item.herEmail) {
                couples.push({
                  label:
                    item.herFirstName +
                    " " +
                    item.herLastName +
                    "(" +
                    item.herEmail +
                    ")",
                  value: item.herEmail,
                });
              }
            });
            const key = "value";
            const arrayUniqueByKey = [
              ...new Map(couples.map((item) => [item[key], item])).values(),
            ];
            setAllCoupleData(arrayUniqueByKey);
          } else {
            //  show retreats with couple columns
            console.log("4");
            setLoadData(false);
            setTimeout(() => {
              const element = document.getElementById("section-1");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth",
                  block: "end",
                  inline: "nearest",
                });
              }
            }, 500);
            setDataCount(res.retreats.length);
            setIsShowData(true);
            setNoRetAttend(false);
            setCoupWithAttenType(false);
            setRetreatsList(res.retreats);
            let couples = [];
            const filteredData = res.retreats.filter(
              (item) =>
                item.accountStatus !== "DIVORCED" &&
                item.accountStatus !== "DECEASED" &&
                item.accountStatus !== "INACTIVE"
            );
            filteredData.forEach((item) => {
              if (item.hisEmail) {
                couples.push({
                  label:
                    item.hisFirstName +
                    " " +
                    item.hisLastName +
                    "(" +
                    item.hisEmail +
                    ")",
                  value: item.hisEmail,
                });
              }
              if (item.herEmail) {
                couples.push({
                  label:
                    item.herFirstName +
                    " " +
                    item.herLastName +
                    "(" +
                    item.herEmail +
                    ")",
                  value: item.herEmail,
                });
              }
            });
            const key = "value";
            const arrayUniqueByKey = [
              ...new Map(couples.map((item) => [item[key], item])).values(),
            ];
            setAllCoupleData(arrayUniqueByKey);
          }
        } else {
          setIsShowData(false);
          setLoadData(false);
          setNoRetAttend(false);
          setCoupWithAttenType(false);
          setRetreatsList([]);
          toast.error(res.msg);
          setTimeout(() => {
            const element = document.getElementById("footer");
            if (element) {
              element.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest",
              });
            }
          }, 500);
        }
      })
      .catch((error: any) => {
        setLoadData(false);
        toast.error(error);
        setTimeout(() => {
          const element = document.getElementById("footer");
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          }
        }, 500);
      });
  };

  const resetForm = () => {
    // document.getElementById("searchForm").reset();
    setSearchQuery(searchInitial);
    setCouplesList([]);
    setRetreatsList([]);
    setIsShowData(false);
    setNoRetAttend(false);
    setCoupWithAttenType(false);
    setSearchFor("retreat");
    setSelectedLocation([]);
    setSelectedZips([]);
    setSelectedStateCity([]);
    setSelectRetreat(null);
    setSelectCouple(null);
    setSelectParish(null);
    setRoleTextArray([]);
    setServiceTextArray([]);
    setTalkTextArray([]);
    setQuickSearchFor("");
    setDataCount([]);
    setRetreatOptions([]);
    setSelectedRetreats([]);
    // setLanguagesOptions([])
    setSelectedLanguages([]);
    setCoupleOptions([]);
    setSelectedCouples([]);
    setParishOptions([]);
    setSelectedParishes([]);
    setSelectedCategories([]);
    setSelectedDeaneries([]);
    geoFiltersRef.current = { categories: [], deaneries: [] };
    getPerishList();
    getTalksList();
    getrolesList();
    getServiceList();
    AllComposedMailList();
    getAllCouples1();
    getAllRetreats();
    getStateCityCouples();
    getRetreatLocation();
    checkPKCouple();
  };

  const getPerishList = async () => {
    await perishApi
      .getAllPerishSearch({ searchFor: searchQuery.searchFor })
      .then((response: any) => {
        const sortedList = sortParishesByName(response.data);
        setParishDataList(sortedList);
        setParishOptions(
          buildParishOptions(
            sortedList,
            geoFiltersRef.current.categories,
            geoFiltersRef.current.deaneries,
          ),
        );
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const getAllRetreats = async () => {
    await retreatApi
      .getAllRetreatSearch()
      .then((response: any) => {
        let retreatList = [];
        response.data &&
          response.data.forEach((item) => {
            if (item.title) {
              retreatList.push({
                label:
                  item && item.title !== null && item.title !== ""
                    ? `${item?.parishName || ""} ${
                        item.language
                          ? `(${item.language[0].toUpperCase()}${item.language.slice(
                              1
                            )}) `
                          : ""
                      }${
                        item.location
                          ? `${item.location[0].toUpperCase()}${item.location.slice(
                              1
                            )}`
                          : ""
                      } ${moment(item.dateFrom).format("MMM DD")} - ${moment(
                        item.dateTo
                      ).format("MMM DD")}, ${moment(item.dateFrom).format(
                        "YYYY"
                      )}`
                    : "",
                value: item.id,
                dateFrom: moment(item.dateFrom),
              });
            }
          });
        // const sort = retreatList.sort((a, b) => b.title - a.title);
        // const sortedList = response.data.sort((a, b) =>
        //   a.title.localeCompare(b.title)
        // );
        setAllRetreatData(response.data);
        // console.log("retreatList----->", retreatList);

        setRetreatOptions(retreatList);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  function handleSelect(data) {
    setselectedData(data);
    let selectedDataa = { ...maildata };
    selectedDataa.retreats = data.map((item, index) => {
      let returnOBj = {
        email: item.label,
        value: item.value,
      };
      return returnOBj;
    });
    setMailData(selectedDataa);
  }

  const ShowCompose = () => {
    setMailShow(true);
    clearfield();
    setDefaultEdtitorContent(initialEditorContent);
    setData({
      // primaryKey: '',
      id: "",
      hisFirstName: "",
      hisLastName: "",
      hisEmail: "",
      hisMobile: "",
      herFirstName: "",
      herLastName: "",
      herEmail: "",
      herMobile: "",
      ciyt: "",
      state: "",
      notes: "",
      userRole: "COUPLE",
    });
    setValidated(false);
  };

  const CloseCompose = () => {
    setMailShow(false);
    setIsDisabled(false);
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  const getroastersOfCouple = async (id) => {
    await adminApi
      .participatedInRetreats({ couple_Id: id })
      .then(async (response) => {
        setRoastersOfCoupleList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const AllComposedMailList = async () => {
    await sendEmailApi
      .getAllComposedMails()
      .then(async (response) => {
        setComposedMails(response.data);
      })
      .catch((error: any) => {
        toast.error(error.toString());
      });
  };

  const clearfield = () => {
    setMailData({
      couple: [],
      subject: "",
      message: defaultEditorContent,
    });
    SetMail_id("");
    setselectedData([]);
  };

  const handleSearchChanges = (event, id = null, text = null) => {
    let { name, value } = event.target;
    const search = { ...searchQuery };
    switch (name) {
      case "primaryKey":
        search.primaryKey = typeof value === "string" ? value.trim() : value;
        break;
      case "cityState":
        search.cityState = value;
        break;
      case "retreatAttended":
        if (value == "false") {
          value = true;
        } else {
          value = false;
        }
        search.retreatAttended = value;
        break;
      case "retreatants":
        let retreatantType = search.retreatants.findIndex((s) => s == value);
        if (retreatantType != -1) {
          search.retreatants.splice(retreatantType, 1);
        } else {
          search.retreatants.push(value);
        }
        break;
      case "language":
        search.language = value;
        break;
      case "service":
        let findId = search.serviceIds.findIndex((id) => id == value);
        let serviceName =
          serviceDataList && serviceDataList.find((item) => item.id == value);
        let temp3 = serviceName.service;

        let serviceIndex3 = serviceTextArray.findIndex((id) => id == temp3);

        if (serviceIndex3 != -1) {
          serviceTextArray.splice(serviceIndex3, 1);
        } else {
          setServiceTextArray((oldArray) => [...oldArray, temp3]);
        }
        if (findId != -1) {
          search.serviceIds.splice(findId, 1);
        } else {
          search.serviceIds.push(value);
        }
        break;
      case "neverService":
        search.neverServedTeam = !search.neverServedTeam;
        break;
      case "serviceRole":
        let roleIndex = search.roleIds.findIndex((id) => id == value);
        let roleName =
          rolesDataList && rolesDataList.find((item) => item.id == value);
        let temp = roleName.role;
        let roleIndex1 = roleTextArray.findIndex((id) => id == temp);
        if (roleIndex1 != -1) {
          roleTextArray.splice(roleIndex1, 1);
        } else {
          setRoleTextArray((oldArray) => [...oldArray, temp]);
        }
        if (roleIndex != -1) {
          search.roleIds.splice(roleIndex, 1);
        } else {
          search.roleIds.push(value);
        }
        break;
      case "neverServiceRole":
        search.neverServiceRole = !search.neverServiceRole;
        break;
      case "talks":
        let talkId = search.talkIds.findIndex((id) => id == value);
        let talkName =
          talksDataList && talksDataList.find((item) => item.talkId == value);
        let temp6 = talkName.talk;
        let talkIndex2 = talkTextArray.findIndex((id) => id == temp6);
        if (talkIndex2 != -1) {
          talkTextArray.splice(talkIndex2, 1);
        } else {
          setTalkTextArray((oldArray) => [...oldArray, temp6]);
        }

        if (talkId != -1) {
          search.talkIds.splice(talkId, 1);
        } else {
          search.talkIds.push(value);
        }
        break;
      case "neverTalk":
        search.neverTalk = !search.neverTalk;
        break;
      case "missingMails":
        search.missingMails = !search.missingMails;
        break;
      case "coupleStatus":
        let status = search.accountStatus.findIndex((s) => s == value);
        if (status != -1) {
          search.accountStatus.splice(status, 1);
        } else {
          search.accountStatus.push(value);
        }
        break;
      case "searchFor":
        search.searchFor = value;
        break;
    }
    setSearchQuery(search);
  };

  const enableAllDates = (e) => {
    let { name, value } = e.target;
    if (value == "true") {
      value = false;
      searchQuery.dateFrom = "";
      searchQuery.dateTo = "";
    } else {
      value = true;
    }
    setAllDates(value);
  };

  const handleSelect1 = (da) => {
    setSelectedStateCity(da);
    let selectedData = { ...searchQuery };
    selectedData.cityState = da.map((item, index) => {
      let returnOBj = {
        label: item.label,
        value: item.value,
      };
      return returnOBj;
    });
    setSearchQuery(selectedData);
  };

  const handleSelectLocation = (val) => {
    setSelectedLocation(val);
    let selectedData = { ...searchQuery };
    selectedData.location = val.map((item, index) => {
      let returnOBj = {
        label: item.label,
        value: item.value,
      };
      return returnOBj;
    });
    setSearchQuery(selectedData);
  };

  const handleSelectRetreat = (val) => {
    setSelectedRetreats(val);
    let selectedRetreatName = { ...selectRetreat };
    selectedRetreatName = val.map((item, index) => {
      return item.label;
    });
    setSelectRetreat(selectedRetreatName);
    let selectedData = { ...searchQuery };
    selectedData.retreatId = val.map((item, index) => {
      return item.value;
    });
    setSearchQuery(selectedData);
  };

  const handleSelectLanguages = (val) => {
    setSelectedLanguages(val);

    let selectedLanguageName = { ...selectLanguage };
    selectedLanguageName = val.map((item, index) => {
      return item.label;
    });
    setSelectLanguage(selectedLanguageName);

    let selectedData = { ...searchQuery };
    selectedData.language = val.map((item, index) => {
      return item.value;
    });
    setSearchQuery(selectedData);
  };

  const handleSelectCouples = (val) => {
    setSelectedCouples(val);

    let selectedCoupleName = { ...selectCouple };
    selectedCoupleName = val.map((item, index) => {
      return item.label;
    });
    setSelectCouple(selectedCoupleName);

    let selectedData = { ...searchQuery };
    selectedData.coupleId = val.map((item, index) => {
      return item.value;
    });
    setSearchQuery(selectedData);
  };

  const handleSelectZip = (val) => {
    setSelectedZips(val);
    let selectedData = { ...searchQuery };
    selectedData.zip = val.map((item, index) => {
      let returnOBj = {
        label: item.label,
        value: item.value,
      };
      return returnOBj;
    });
    setSearchQuery(selectedData);
  };

  const handleSelectParishes = (val) => {
    const parishIds = val.map((item) => item.value);
    const filteredList = allRetreatData.filter((item) =>
      parishIds.includes(item.parishId)
    );
    let retreatList = filteredList.map((item) => ({
      label:
        item && item.title !== null && item.title !== ""
          ? `${item?.parishName || ""} ${
              item.language
                ? `(${item.language[0].toUpperCase()}${item.language.slice(
                    1
                  )}) `
                : ""
            }${
              item.location
                ? `${item.location[0].toUpperCase()}${item.location.slice(1)}`
                : ""
            } ${
              moment(item.dateFrom).format("MMM DD") +
              " - " +
              moment(item.dateTo).format("MMM DD") +
              ", " +
              moment(item.dateFrom).format("YYYY")
            }`
          : "",
      value: item.id,
      dateFrom: moment(item.dateFrom),
      disabled: false,
    }));
    if (!val.length) {
      let retreatListData = [];
      allRetreatData &&
        allRetreatData.forEach((item) => {
          if (item.title) {
            retreatListData.push({
              label:
                item && item.title !== null && item.title !== ""
                  ? `${item?.parishName || ""} ${
                      item.language
                        ? `(${item.language[0].toUpperCase()}${item.language.slice(
                            1
                          )}) `
                        : ""
                    }${
                      item.location
                        ? `${item.location[0].toUpperCase()}${item.location.slice(
                            1
                          )}`
                        : ""
                    } ${
                      moment(item.dateFrom).format("MMM DD") +
                      " - " +
                      moment(item.dateTo).format("MMM DD") +
                      ", " +
                      moment(item.dateFrom).format("YYYY")
                    }`
                  : "",
              value: item.id,
              dateFrom: moment(item.dateFrom),
            });
          }
        });
      setRetreatOptions(retreatListData);
      setSelectedParishes(val);
      let selectedParishName = val.map((item) => item.label);
      setSelectParish(selectedParishName);
      let selectedData = { ...searchQuery };
      selectedData.parisheId = val.map((item) => item.value);
      setSearchQuery(selectedData);
    } else {
      setRetreatOptions(retreatList);
      setSelectedParishes(val);
      let selectedParishName = { ...selectParish };
      selectedParishName = val.map((item, index) => {
        return item.label;
      });
      setSelectParish(selectedParishName);
      let selectedData = { ...searchQuery };
      selectedData.parisheId = val.map((item, index) => {
        return item.value;
      });
      setSearchQuery(selectedData);
    }
  };

  const syncGeoSelection = (categories, deaneries) => {
    const categorySet = new Set((categories || []).map((item) => String(item.value)));
    const deaneriesKept = (deaneries || []).filter(
      (item) =>
        !categorySet.size || categorySet.has(String(item.parishCategoryId)),
    );
    const nextOptions = buildParishOptions(
      parishDataList,
      categories,
      deaneriesKept,
    );
    const allowed = new Set(nextOptions.map((item) => String(item.value)));
    const parishesKept = (selectedParishes || []).filter((item) =>
      allowed.has(String(item.value)),
    );
    geoFiltersRef.current = {
      categories: categories || [],
      deaneries: deaneriesKept,
    };
    setSelectedCategories(categories || []);
    setSelectedDeaneries(deaneriesKept);
    setParishOptions(nextOptions);
    setSelectedParishes(parishesKept);
    setSelectParish(parishesKept.map((item) => item.label));
    setSearchQuery((current) => ({
      ...current,
      parishCategoryId: (categories || []).map((item) => item.value),
      deaneryId: deaneriesKept.map((item) => item.value),
      parisheId: parishesKept.length
        ? parishesKept.map((item) => item.value)
        : 0,
    }));
  };

  const handleSelectCategories = (val) => {
    syncGeoSelection(val || [], selectedDeaneries);
  };

  const handleSelectDeaneries = (val) => {
    syncGeoSelection(selectedCategories, val || []);
  };

  const handleSearchFor = (e) => {
    let { value } = e.target;
    setSearchFor(value);
    let d = { ...searchQuery };
    d.searchFor = value;
    setSearchQuery(d);
    setCouplesList([]);
    setRetreatsList([]);
    setIsShowData(false);
    setNoRetAttend(false);
    setCoupWithAttenType(false);
    setSelectedStateCity([]);
    setSelectedLocation([]);
  };

  const checkPKCouple = async () => {
    await authApi
      .checkPKCouple()
      .then((res: any) => {
        if (res.success) {
          if (res.data != null) {
            let incPK = res.data + 1;
            setAlreadyPk(incPK);
            let d = { ...data };
            d.primaryKey = incPK;
            setData(d);
          } else {
            let defaultPK = 1001;
            setAlreadyPk(defaultPK);
            let d = { ...data };
            d.primaryKey = defaultPK;
            setData(d);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const handleChanges1 = (e) => {
    let { name, value } = e.target;
    let d = { ...maildata };
    d[name] = value;
    setMailData(d);
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      let d = { ...maildata };
      if (allCoupleData.length) {
        const maildta = allCoupleData.map((item, index) => {
          let jsdata = {
            email: item.label,
            value: item.value,
          };
          return jsdata;
        });
        d.couple = maildta;
      }
      d.message = Message;
      sendEmailApi
        .addSendEmail(d)
        .then(async (res) => {
          if (res.success) {
            toast.success(res.msg);
            clearfield();
            setSendEmailList(res.data);
            AllComposedMailList();
            setMailShow(false);
            
          } else {
            toast.error(res.msg);
          }
        })
        .catch((error: any) => {
          toast.error(error);
        });
    }
    setValidated(true);
  };

  const editCouple = async (id) => {
    setEdiUserIdClicked(id);
    setIsTempUpload(false);
    setIsTempUpload2(false);
    let d = { ...data };
    await adminApi
      .getCouplesDetail({ coupleId: id })
      .then(async (res) => {
        if (isProtectedDemoCouple(res.data[0].hisEmail, res.data[0].herEmail)) {
          setIsEditAdmin(true);
        }
        if (res.success) {
          d.id = res.data[0].id;
          d.primaryKey = res.data[0].primaryKey;
          d.hisFirstName = res.data[0].hisFirstName;
          d.hisLastName = res.data[0].hisLastName;
          d.hisEmail = res.data[0].hisEmail;
          d.hisMobile = res.data[0].hisMobile;
          d.herFirstName = res.data[0].herFirstName;
          d.herLastName = res.data[0].herLastName;
          d.herEmail = res.data[0].herEmail;
          d.herMobile = res.data[0].herMobile;
          d.city = res.data[0].city;
          d.state = res.data[0].state;
          d.zip = res.data[0].zip;
          d.notes = res.data[0].notes;
          d.parishId = res.data[0].parishId;
          d.imageUrl = res.data[0].imageUrl;
          d.address = res.data[0].address;
          d.allergies = res.data[0].allergies;
          d.anniversary_date = res.data[0].anniversary_date
            ? new Date(res.data[0].anniversary_date)
            : "";
          d.under_age_35 = res.data[0].under_age_35;
          d.emergency_name1 = res.data[0].emergency_name1;
          d.emergency_relationship1 = res.data[0].emergency_relationship1;
          d.emergency_phone1 = res.data[0].emergency_phone1;
          d.emergency_name2 = res.data[0].emergency_name2;
          d.emergency_relationship2 = res.data[0].emergency_relationship2;
          d.emergency_phone2 = res.data[0].emergency_phone2;
          d.hear_us = res.data[0].hear_us;
          d.referral_from_a_friend_or_family_member =
            res.data[0].referral_from_a_friend_or_family_member;
          setData(d);
          setOldValues(res.data[0]);
          
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error: any) => {
        toast.error(error);
      });
  };

  const {
    retreatsColumns,
    retreatColWithCouple,
    coupleColWithRetAttend,
    coupleColWithAttendType,
  } = buildSearchColumns({
    navigate,
    renderTooltip,
    popover,
    editCouple,
    setShowREgModal,
    getroastersOfCouple,
  });

  const deaneryOptions = allDeaneries
    .filter((deanery) => {
      if (!selectedCategories.length) return true;
      return selectedCategories.some(
        (category) => String(category.value) === String(deanery.parishCategoryId),
      );
    })
    .map((deanery) => ({
      label: deanery.deaneryName,
      value: deanery.id,
      parishCategoryId: deanery.parishCategoryId,
    }));

  const { handleExport, exportFlockNotes, exportPdf } = createSearchExports({
    isShowData,
    retreatsList,
    noRetAttend,
    coupWithAttenType,
    quickSearchFor,
  });

  return (
    <MasterPageShell>
      <div className={styles.page}>
        {open1 ? (
          <div className={`${styles.panel} ${styles.filterPanel}`}>
            <div className={styles.panelHeader}>
              <div className={styles.panelTitleWrap}>
                <span className={styles.panelGlyph}>
                  <SlidersHorizontal size={16} />
                </span>
                <div>
                  <h3 className={styles.panelTitle}>Filters</h3>
                  <p className={styles.panelKicker}>
                    Narrow by date, parish, and service.
                  </p>
                </div>
              </div>
              <button
                type="button"
                className={styles.toggle}
                onClick={() => setOpen1(false)}
              >
                <EyeOff size={14} />
                Hide Filters
              </button>
            </div>
            <SearchForm
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handleSearchFor={handleSearchFor}
              handleSearchChanges={handleSearchChanges}
              allDates={allDates}
              enableAllDates={enableAllDates}
              parishOptions={parishOptions}
              selectedParishes={selectedParishes}
              handleSelectParishes={handleSelectParishes}
              categoryOptions={categoryOptions}
              selectedCategories={selectedCategories}
              handleSelectCategories={handleSelectCategories}
              deaneryOptions={deaneryOptions}
              selectedDeaneries={selectedDeaneries}
              handleSelectDeaneries={handleSelectDeaneries}
              retreatOptions={retreatOptions}
              selectedRetreats={selectedRetreats}
              handleSelectRetreat={handleSelectRetreat}
              languagesOptions={languagesOptions}
              selectedLanguages={selectedLanguages}
              handleSelectLanguages={handleSelectLanguages}
              coupleOptions={coupleOptions}
              selectedCouples={selectedCouples}
              handleSelectCouples={handleSelectCouples}
              searchFor={searchFor}
              location={location}
              selectedLocation={selectedLocation}
              handleSelectLocation={handleSelectLocation}
              ciytState={ciytState}
              selectedStateCity={selectedStateCity}
              handleSelect1={handleSelect1}
              zip={zip}
              selectedZips={selectedZips}
              handleSelectZip={handleSelectZip}
              serviceDataList={serviceDataList}
              rolesDataList={rolesDataList}
              talksDataList={talksDataList}
              location1={location1}
              searchRetreatsAndCouples={searchRetreatsAndCouples}
              resetForm={resetForm}
            />
          </div>
        ) : (
          <div className={styles.showBar}>
            <button
              type="button"
              className={styles.toggle}
              onClick={() => setOpen1(true)}
            >
              <Eye size={14} />
              Show Filters
            </button>
          </div>
        )}

        <div className={`${styles.panel} ${styles.resultsPanel}`}>
          <SearchResultsBar
            quickSearchFor={quickSearchFor}
            dataCount={dataCount}
            searchQuery={searchQuery}
            userData={userData}
            onExportExcel={handleExport}
            onExportPdf={exportPdf}
            onExportFlockNotes={exportFlockNotes}
            onSendEmail={ShowCompose}
          />
          <SearchTables
            LoadData={LoadData}
            isShowData={isShowData}
            noRetAttend={noRetAttend}
            coupWithAttenType={coupWithAttenType}
            retreatsList={retreatsList}
            retreatsColumns={retreatsColumns}
            retreatColWithCouple={retreatColWithCouple}
            coupleColWithRetAttend={coupleColWithRetAttend}
            coupleColWithAttendType={coupleColWithAttendType}
          />
        </div>

        {showRegModal ? (
          <UpdateCouplePopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKCouple();
              setEdiUserIdClicked("");
              CloseCompose();
              searchRetreatsAndCouples();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishOptions}
            setParishList={setParishOptions}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfCoupleList={roastersOfCoupleList}
            getAllCouples={searchRetreatsAndCouples}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            isTempUpload2={isTempUpload2}
            setIsTempUpload={setIsTempUpload}
            setIsTempUpload2={setIsTempUpload2}
          />
        ) : null}

        <ComposeEmailModal
          mailshow={mailshow}
          setMailShow={setMailShow}
          setIsDisabled={setIsDisabled}
          validated={validated}
          handleSubmit1={handleSubmit1}
          isDisabled={isDisabled}
          maildata={maildata}
          handleChanges1={handleChanges1}
          defaultEditorContent={defaultEditorContent}
          setMessage={setMessage}
          CloseCompose={CloseCompose}
          allCoupleData={allCoupleData}
        />
      </div>
    </MasterPageShell>
  );
};

export default SearchData;
